export default "__VITE_ASSET__9919c231__"